<template lang="pug">
    .re-contact-allergyanamnesis
        h4 Сенсибилизация
        .row.column
            app-choice.re-contact-allergyanamnesis--sencibility(
                v-for="(item, id) in sensitization"
                :key="id"
                v-model="item.value"
                type="checkbox"
                :label="item.name"
                :disabled="item.old"
            )

        h4 Аллергены и проявления
        allergens-block(
            v-model="allergens"
            ref="allergens"
            is-re-contact
        )

        h4 НПВС и проявления
        npvs-block(
            v-model="npvs"
            ref="npvs"
            is-re-contact
        )

        h4 Лекарственные препараты и проявления
        medicines-block(
            v-model="medicines"
            ref="medicines"
            is-re-contact
        )

        h4 Пищевая аллергия
        food-allergies-block(
            v-model="foodAllergies"
            ref="foodAllergies"
            is-re-contact
        )

        h4 Другое
        .row
            app-text-field(
                v-model="other"
                label="Другое"
                is-textarea
            )

        .row.sticky-buttons-block
            app-button(
                large
                @click="saveAndContinue"
            ) Сохранить и продолжить заполнение
            app-button(
                :loading="saveLoading"
                large
                color="white"
                @click="saveAndClose"
            ) Сохранить и закончить заполнение
            app-link.app-link--red.app-link--left-margin(@click="close") Закрыть без сохранения
</template>

<script>
import AllergensBlock from '@/components/pages/patients/blocks/allergyanamnesis/AllergensBlock';
import NpvsBlock from '@/components/pages/patients/blocks/allergyanamnesis/NpvsBlock';
import MedicinesBlock from '@/components/pages/patients/blocks/allergyanamnesis/MedicinesBlock';
import FoodAllergiesBlock from '@/components/pages/patients/blocks/allergyanamnesis/FoodAllergiesBlock';
import saving from '@/mixins/saving';

export default {
    name: 're-contact-allergyanamnesis',

    components: {
        AllergensBlock,
        NpvsBlock,
        MedicinesBlock,
        FoodAllergiesBlock,
    },

    mixins: [saving],

    data: () => ({
        sensitization: {
            sensitiveEveryday: {
                name: 'Сенсибилизация к бытовым&nbsp;аллергенам',
                value: false,
            },
            sensitiveEpiderm: {
                name: 'Сенсибилизация к эпидермальным аллергенам',
                value: false,
            },
            sensitivePollen: {
                name: 'Сенсибилизация к пыльцевым&nbsp;аллергенам',
                value: false,
            },
            sensitiveMushrooms: {
                name: 'Сенсибилизация к аллергенам непатогенных плесневых грибов',
                value: false,
            },
            sensitiveFood: {
                name: 'Сенсибилизация к пищевым&nbsp;аллергенам',
                value: false,
            },
        },
        allergens: [],
        npvs: [],
        medicines: [],
        foodAllergies: [],
        other: '',
    }),

    mounted() {
        if (this.lastData && !this.hasDataFromLocalStorage) {
            const allergoanamnez = this.lastData.allergoanamnez;
            if (allergoanamnez) {
                this.sensitization.sensitiveEveryday.value = allergoanamnez.sensitive_everyday;
                this.sensitization.sensitiveEveryday.old = Boolean(allergoanamnez.sensitive_everyday);
                this.sensitization.sensitiveEveryday.value = allergoanamnez.sensitive_everyday;
                this.sensitization.sensitiveEveryday.old = Boolean(allergoanamnez.sensitive_everyday);
                this.sensitization.sensitiveEpiderm.value = allergoanamnez.sensitive_epiderm;
                this.sensitization.sensitiveEpiderm.old = Boolean(allergoanamnez.sensitive_epiderm);
                this.sensitization.sensitivePollen.value = allergoanamnez.sensitive_pollen;
                this.sensitization.sensitivePollen.old = Boolean(allergoanamnez.sensitive_pollen);
                this.sensitization.sensitiveMushrooms.value = allergoanamnez.sensitive_mushrooms;
                this.sensitization.sensitiveMushrooms.old = Boolean(allergoanamnez.sensitive_mushrooms);
                this.sensitization.sensitiveFood.value = allergoanamnez.sensitive_food;
                this.sensitization.sensitiveFood.old = Boolean(allergoanamnez.sensitive_food);

                this.other = allergoanamnez.other || '';

                this.allergens = this.$refs.allergens.getFormattedSavedFields(allergoanamnez.allergens);

                this.npvs = this.$refs.npvs.getFormattedSavedFields(allergoanamnez.npvs);

                this.medicines = this.$refs.medicines.getFormattedSavedFields(allergoanamnez.medicines);

                this.foodAllergies = this.$refs.foodAllergies.getFormattedSavedFields(allergoanamnez.food_allergies);
            }
        }
    },

    methods: {
        getFormFields() {
            const obj = {
                allergoanamnez: {
                    sick_relatives: this.lastData.allergoanamnez.sick_relatives.map(s => ({
                        relatives_id: s.relative.id,
                        illnesses_id: s.illness.id,
                        type: s.type,
                    })),

                    sensitive_everyday: +this.sensitization.sensitiveEveryday.value,
                    sensitive_epiderm: +this.sensitization.sensitiveEpiderm.value,
                    sensitive_pollen: +this.sensitization.sensitivePollen.value,
                    sensitive_mushrooms: +this.sensitization.sensitiveMushrooms.value,
                    sensitive_food: +this.sensitization.sensitiveFood.value,

                    allergens: this.$refs.allergens.getFieldsForSave(),
                    npvs: this.$refs.npvs.getFieldsForSave(),
                    medicines: this.$refs.medicines.getFieldsForSave(),
                    food_allergies: this.$refs.foodAllergies.getFieldsForSave(),
                    other: this.other,
                },
            };
            return obj;
        },

        checkValid() {
            if (this.$refs.allergens.$v.$invalid
                || this.$refs.npvs.$v.$invalid
                || this.$refs.medicines.$v.$invalid
                || this.$refs.foodAllergies.$v.$invalid) {
                this.$refs.allergens.$v.$touch();
                this.$refs.npvs.$v.$touch();
                this.$refs.medicines.$v.$touch();
                this.$refs.foodAllergies.$v.$touch();
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss">
.re-contact-allergyanamnesis {
    @include mobile_or_P {
        max-width: 100vmin;
        margin: 0 auto;

        h4 {
            margin-bottom: 1rem;
        }

        .re-contact-allergyanamnesis {
            &--sencibility {
                max-width: 85%;

                label {
                    white-space: initial;
                }
            }
        }
    }
}
</style>
